
<p-dialog class="create-scenario-popup" 
    header="Application settings" 
    [(visible)]="isVisible"
    [modal]="true"
    [closable]="true" 
  [styleClass]="'modal-settings-size'" 
    (onShow)="onShowModal()"
    (onHide)="onCloseModal()">
   
        <div class="content-wrapper">
      <mat-tab-group (selectedIndexChange)="onTabChange($event)">
        <mat-tab label="Users settings" *ngIf="canViewUsersTab()">
                  <div class="component-container">
                    @if (!hasOpenedUsers() || isLoadingUsers()) {
                      <div class="tab-loading-spinner">
                        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                        <p>Loading...</p>
                      </div>
                    } @else {
                      <ng-container *ngComponentOutlet="usersSettingsComp"></ng-container>
                    }
                  </div>
                </mat-tab>
        <mat-tab label="Permissions settings" *ngIf="canViewPermissionsTab()">
                  <div class="component-container">
                    @if (!hasOpenedPermissions() || isLoadingPermissions()) {
                      <div class="tab-loading-spinner">
                        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                        <p>Loading...</p>
                      </div>
                    } @else {
                      <ng-container *ngComponentOutlet="permissionsSettingsComp"></ng-container>
                    }
                  </div>
                </mat-tab>
              </mat-tab-group>
        </div>
 
</p-dialog>

